import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { themes, customProps } from './buttonConfig';

var Button = /*#__PURE__*/function (_PureComponent) {
  _inherits(Button, _PureComponent);

  var _super = _createSuper(Button);

  function Button() {
    var _this;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getProps", function () {
      var _this$props = _this.props,
          href = _this$props.href,
          type = _this$props.type,
          className = _this$props.className,
          isBlock = _this$props.isBlock,
          theme = _this$props.theme,
          size = _this$props.size,
          iconRounded = _this$props.iconRounded,
          loading = _this$props.loading,
          target = _this$props.target,
          icon = _this$props.icon,
          children = _this$props.children,
          iconRight = _this$props.iconRight,
          blockAlignedLeft = _this$props.blockAlignedLeft,
          blockAlignedRight = _this$props.blockAlignedRight,
          loadingFixedWidth = _this$props.loadingFixedWidth;
      var newProps = Object.keys(_this.props).reduce(function (newObj, key) {
        if (customProps.indexOf(key) === -1) {
          newObj[key] = _this.props[key];
        }

        return newObj;
      }, {});
      var applyTheme = themes[Object.keys(themes).filter(function (themeKey) {
        return themeKey === theme;
      })];
      var cssClass = classnames('tds-btn', {
        'tds-btn--sm': size === 'sm',
        'tds-btn--lg': size === 'lg',
        'tds-btn--xl': size === 'xl',
        'tds-btn--md': size === 'md',
        'tds-btn--block': isBlock && !iconRounded,
        'tds-btn--block--left': isBlock && blockAlignedLeft && !iconRounded,
        'tds-btn--block--right': isBlock && blockAlignedRight && !iconRounded,
        'tds-btn--loading': loading,
        'tds-btn--loading-fixed-width': loading && loadingFixedWidth,
        'tds-btn--with-icon': !!icon || loading,
        'tds-btn--with-icon-right': !!iconRight,
        'tds-btn--icon-only': !children && (!!icon || loading),
        'tds-btn--icon-rounded': !children && (!!icon || loading) && iconRounded
      }, className, theme && applyTheme);
      return _objectSpread(_objectSpread({}, newProps), {}, {
        type: !href ? type : null,
        href: href,
        target: target,
        disabled: newProps.disabled || loading,
        className: cssClass
      });
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props2 = _this.props,
          href = _this$props2.href,
          children = _this$props2.children,
          loading = _this$props2.loading,
          icon = _this$props2.icon,
          iconRight = _this$props2.iconRight;

      if (!children && !icon) {
        throw new Error('Button should have at least either children or icon');
      }

      var Element = href ? 'a' : 'button';
      var canDisplayIcon = icon || loading;
      var childrenWrapper = canDisplayIcon ? /*#__PURE__*/React.createElement("span", null, children) : children;
      var iconClassName = loading ? 'loading' : icon;
      var iconElement = canDisplayIcon ? /*#__PURE__*/React.createElement("i", {
        className: "icon icon--".concat(iconClassName)
      }) : null; // We need to wrap the loading icon element on a div
      // because the spinner icon doesn't have the same padding
      // as other icons, therefore we need to scale it down.
      // transform: scale doesn't work on <i> element, so it needs
      // to be applied on a div (to then apply the css transformation there).

      var wrappedIconElement = loading ? /*#__PURE__*/React.createElement("div", {
        className: "icon--loading_wrapper"
      }, iconElement) : iconElement;
      return /*#__PURE__*/React.createElement(Element, _this.getProps(), canDisplayIcon && !iconRight && wrappedIconElement, children && childrenWrapper, canDisplayIcon && iconRight && wrappedIconElement);
    });

    return _this;
  }

  return Button;
}(PureComponent);

_defineProperty(Button, "propTypes", {
  /**
   * If you set href, nothing will change in terms of UI
   * apart the type of the element which will be dynamically become `<a>`.
   * _Probably we will deprecate (w/ a warn) this in the near future._
   */
  href: PropTypes.string,

  /**
   * Related to `href` prop. **Do not use it** if it's a normal button
   */
  target: PropTypes.string,

  /**
   * An html button by default is type="submit"
   * You can pass `type="button"` if you don't want the button
   * to act as a submit
   */
  type: PropTypes.string,
  theme: PropTypes.oneOf(['primary', // main
  'primary-consent', 'secondary', 'tertiary', 'primary-monotone', // monotone
  'secondary-monotone', 'tertiary-monotone', 'primary-inverse', // inverse
  'secondary-inverse', 'tertiary-inverse', 'primary-warning', // warning
  'secondary-warning', 'tertiary-warning']),
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),

  /**
   * If you want to pass your custom className, you can do it.
   * (It's not recommended tho)
   */
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),

  /**
   * If you want the button to take the full available width
   */
  isBlock: PropTypes.bool,

  /**
   * Kinda self explanatory: if you want the alignment of the children of the block button to be on the left.
   * It will work _just_ if you set `isBlock`
   */
  blockAlignedLeft: PropTypes.bool,

  /**
   * Kinda self explanatory: if you want the alignment of the children of block button to be on the right.
   * It will work _just_ if you set `isBlock`
   */
  blockAlignedRight: PropTypes.bool,

  /**
   * If you want the button to appear in loading state.
   * So, it will have a spinner spinning icon and will be disabled.
   * It's **super** useful when you're submitting a form or while doing an async action.
   * So you also prevent people for clicking twice
   */
  loading: PropTypes.bool,

  /**
   * If you want the loading state to keep the button with its default size.
   * This will set the text hidden and place the loading icon as absolute in the center
   * of the button.
   * **Shouldn't be used when you have an icon on the button**
   */
  loadingFixedWidth: PropTypes.bool,

  /**
   * Buttons should only have strings as children, but you can pass whatever.
   * If no children are passed but you set the `icon` prop (see prop description)
   * the button will display just the icon.
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  /**
   * If you pass an icon string as a prop, it will automagically add
   * an icon element as a children.
   * So, if you pass `whatever`, it will yield `<i className={'icon icon--whatever} />`
   * You will then **need** to add your `.icon--whatever { @include generate-icon(tds-whatever, $color-whatever); }` on your application's scss.
   * We support `plus` and `remove` (as they're widely used) out of the box **for main themes**, so you don't need to specify them on your css.
   */
  icon: PropTypes.string,

  /**
   * By default icon are placed on the left. You can place them on the right if you want.
   */
  iconRight: PropTypes.bool,

  /**
   * If you don't have children on your button, and you want to have a rounded icon button
   * you can pass this prop.
   * Will be ignored if there are children (text).
   */
  iconRounded: PropTypes.bool
});

_defineProperty(Button, "defaultProps", {
  theme: 'primary',
  size: 'md',
  loading: false,
  href: null,
  target: null,
  type: null,
  className: '',
  isBlock: false,
  children: null,
  icon: '',
  iconRight: false,
  iconRounded: false,
  blockAlignedLeft: false,
  blockAlignedRight: false,
  loadingFixedWidth: false
});

export { Button as default };